import React from 'react';

import { UseDisclosureProps } from '@chakra-ui/react';

import { BlueprintPolicies } from 'containers/PolicyHub/Blueprints/Components/Blueprint/BlueprintPolicies';
import { BlueprintDashboard } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Details/BlueprintDashboard';
import { PolicyExceptions } from 'containers/PolicyHub/Blueprints/Components/Blueprint/Exceptions/PolicyExceptions';
import { useBlueprintsContext } from 'containers/PolicyHub/Blueprints/hooks/context';

interface Props {
  addPolicy: UseDisclosureProps;
}

export const BlueprintDetails = (props: Props) => {
  const { addPolicy } = props;
  const { showPolicies, showExceptions } = useBlueprintsContext();

  return showPolicies ? (
    <BlueprintPolicies addPolicy={addPolicy} />
  ) : showExceptions ? (
    <PolicyExceptions />
  ) : (
    <BlueprintDashboard />
  );
};
